import React from 'react'
import { Button, List, Skeleton, Typography } from 'antd'
import { Badge, SimpleCard } from '@components'
import { isEventLive, isEventUpcoming } from '@helpers'
import PropTypes from 'prop-types'

import './EventsList.less'

const EventsList = ({
  activeEvent,
  className,
  emptyMessage,
  events,
  title,
  handleEventChange,
  handleShowMoreEvents,
  loading,
  perPage
}) => {
  const getBadgeType = event => {
    if (!event.open_parents) {
      return 'highlight'
    }

    if (isEventLive(event, "millisecond")) {
      return 'live'
    }

    if (isEventLive(event)) {
      return 'success'
    }

    if (isEventUpcoming(event)) {
      return 'warning'
    }

    return 'info-dark'  
  }

  const paginatedEvents = [...events].splice(0, perPage)
  const totalNoOfEvents = events.length

  return (
    <SimpleCard color='secondary' className={`${className} sb-event-list`}>
      <div className='sb-event-list__header'>
        <Typography.Title level={5}>{title}</Typography.Title>
      </div>

      {loading && (
        <Skeleton title={false} paragraph={{ rows: 5, width: ['100%', '100%', '100%', '100%', '100%'] }} active />
      )}

      {!loading && (
        <React.Fragment>
          <List
            className='sb-event-list__list'
            dataSource={paginatedEvents}
            size='small'
            locale={{ emptyText: emptyMessage }}
            renderItem={event => {
              const badgeType = getBadgeType(event)
              const isActiveEvent = activeEvent && activeEvent.id === event.id

              return (
                <List.Item className={`sb-event-list__item ${isActiveEvent ? 'sb-event-list__item--active' : ''}`}>
                  <div className='sb-event-list__title'>
                    <Button type='link' onClick={() => handleEventChange(event.id)}>
                      {event.title}
                    </Button>
                  </div>

                  <Badge className='sb-event-list__badge' size='small' type={badgeType}>
                    {event.duration_badge}
                  </Badge>
                </List.Item>
              )
            }}
          />

          {perPage < totalNoOfEvents && (
            <div className='sb-event-list__more'>
              <Button type='link' size='small' onClick={() => handleShowMoreEvents()}>
                Show More...
              </Button>
            </div>
          )}
        </React.Fragment>
      )}
    </SimpleCard>
  )
}

EventsList.props = {
  activeEvent: PropTypes.object,
  className: PropTypes.string,
  emptyMessage: PropTypes.string.isRequired,
  events: PropTypes.array.isRequired,
  handleEventChange: PropTypes.func.isRequired,
  perPage: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  handleShowMoreEvents: PropTypes.func.isRequired
}

EventsList.defaultProps = {
  activeEvent: null,
  className: '',
  loading: false
}

export default EventsList
